import {
  BooleanInput,
    Edit,
    NullableBooleanInput,
    required,
    SelectInput,
    SimpleForm,
    TextInput,
  } from 'react-admin';
  
  export const ClergyEdit = () => (
    <Edit>
      <SimpleForm>
      <SelectInput source="title" helperText={false} choices={[
          { id: 'Rabbi', name: 'Rabbi' },
          { id: 'Rabba', name: 'Rabba' },
          { id: 'Cantor', name: 'Cantor' },
          { id: 'Shomer', name: 'Shomer' },
        ]}/>
        <TextInput source="name" validate={[required()]} />
        <TextInput source="address" />
        <TextInput source="city" />
        <TextInput source="state" />
        <TextInput source="postal_code" />
        <TextInput source="phone_number" />
        <BooleanInput source="active" />
      </SimpleForm>
    </Edit>
  );
  